module.exports = __webpack_public_path__ + "static/media/technology-action-data.637ab8b0.png";